module.exports = __webpack_public_path__ + "static/media/S4N7.c7060257.svg";